import { CareerPathsSection, StaticCareerPathsSectionProps } from './career-paths-section';
import { CourseCollectionsSection, StaticCourseCollectionsSectionProps } from './course-collections-section';
import { RecommendedProgramsSection, StaticRecommendedProgramsSectionProps } from './recommended-programs-section';
import { SchoolFaqsSection, StaticSchoolFaqsSectionProps } from './school-faqs-section';
import { SchoolHeroSection, StaticSchoolHeroSectionProps } from './school-hero-section';
import { SchoolLibrarySection, StaticSchoolLibrarySectionProps } from './school-library-section';
import { SchoolTestimonialsSection, StaticSchoolTestimonialsSectionProps } from './school-testimonials-section';

export type SchoolLandingPageProps = {
  staticSchoolHeroSectionProps: StaticSchoolHeroSectionProps;
  staticCourseCollectionsSectionProps: StaticCourseCollectionsSectionProps;
  staticRecommendedProgramsSectionProps: StaticRecommendedProgramsSectionProps;
  staticCareerPathsSectionProps: StaticCareerPathsSectionProps;
  staticSchoolFaqsSectionProps: StaticSchoolFaqsSectionProps;
  staticSchoolTestimonialsSectionProps: StaticSchoolTestimonialsSectionProps;
  staticSchoolLibrarySectionProps: StaticSchoolLibrarySectionProps;
};

export function SchoolLandingPage({
  staticSchoolHeroSectionProps,
  staticCourseCollectionsSectionProps,
  staticRecommendedProgramsSectionProps,
  staticCareerPathsSectionProps,
  staticSchoolFaqsSectionProps,
  staticSchoolTestimonialsSectionProps,
  staticSchoolLibrarySectionProps,
}: SchoolLandingPageProps) {
  return (
    <>
      <SchoolHeroSection {...staticSchoolHeroSectionProps} />
      {staticCourseCollectionsSectionProps && <CourseCollectionsSection {...staticCourseCollectionsSectionProps} />}
      {staticRecommendedProgramsSectionProps && (
        <RecommendedProgramsSection {...staticRecommendedProgramsSectionProps} />
      )}
      {staticCareerPathsSectionProps && <CareerPathsSection {...staticCareerPathsSectionProps} />}
      {staticSchoolFaqsSectionProps && <SchoolFaqsSection {...staticSchoolFaqsSectionProps} />}
      {staticSchoolTestimonialsSectionProps && <SchoolTestimonialsSection {...staticSchoolTestimonialsSectionProps} />}
      {staticSchoolLibrarySectionProps && <SchoolLibrarySection {...staticSchoolLibrarySectionProps} />}
    </>
  );
}
